import Radio, { RadioProps } from '@mui/material/Radio';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const CustomRadio = (props: RadioProps) => {
  return (
    <Radio
      tabIndex={0}
      className={'custom-radio'}
      classes={{ checked: 'checked' }}
      checkedIcon={<RadioButtonCheckedIcon />}
      icon={<RadioButtonUncheckedOutlinedIcon />}
      {...props}
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          (e.target as HTMLInputElement).click();
        }
      }}
    />
  );
};

export default CustomRadio;
